import React from 'react'

import { joinStringsWithBullet } from '@/shared/functions/String/string.functions'
import { Edit } from '@mui/icons-material'
import { Box, IconButton, Typography } from '@mui/material'

import Avatar from '../../../Avatar/Avatar.component'

import styles from './RecipientWidget.styles'
import { RecipientWidgetProps } from './RecipientWidget.types'

const RecipientWidget: React.FC<RecipientWidgetProps> = ({ recipient, onEditRecipient }) => {
  const phoneAndEmail = joinStringsWithBullet(
    [recipient.phone, recipient.email].filter((value): value is string => Boolean(value))
  )

  const addressLine = joinStringsWithBullet([
    recipient.streetAddress,
    recipient.city,
    recipient.stateProvince,
    recipient.postalCode,
    recipient.country
  ])

  return (
    <Box sx={styles.container}>
      <Box sx={styles.header}>
        <Typography sx={styles.titleText}>Recipient</Typography>

        {onEditRecipient && (
          <IconButton size="small" sx={styles.editIcon} onClick={onEditRecipient}>
            <Edit sx={{ fontSize: 14 }} />
          </IconButton>
        )}
      </Box>

      <Box sx={styles.detailsContainer}>
        <Avatar firstName={recipient.firstName} lastName={recipient.lastName} size={'medium'} />

        <Box sx={styles.detailsContent}>
          <Typography sx={styles.nameText}>{`${recipient.firstName} ${recipient.lastName}`.trim()}</Typography>

          {phoneAndEmail && <Typography sx={styles.detailText}>{phoneAndEmail}</Typography>}

          {addressLine && <Typography sx={styles.detailText}>{addressLine}</Typography>}
        </Box>
      </Box>
    </Box>
  )
}

export default RecipientWidget
